import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  CircularProgress,
  Pagination,
  Paper,
  Grid,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ListItemPet from '../ListItemPet';
import { fetchReport, handleError } from '../../utils/lib';
import { useSnackbar } from '../../providers/SnackBarProvider';
import { useNavigate } from 'react-router-dom';

const BirthdayPetsReport = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const snackbar = useSnackbar();
  const navigate = useNavigate();

  // Load saved search parameters when returning to the page
  useEffect(() => {
    fetchBirthdayPets(page);
  }, []);

  const fetchBirthdayPets = async (pageNumber) => {
    setIsLoading(true);
    try {
      const response = await fetchReport('BIRTHDAY_PETS', pageNumber);
      setData(response);
    } catch (error) {
      handleError(error, snackbar);
    } finally {
      setIsLoading(false);
    }
  };
  
  const handlePageChange = (event, value) => {
    setPage(value);
    fetchBirthdayPets(value);
  };

  const handlePetClick = (pet) => {
    navigate('/main/view-pet', { state: { id: pet.id } });
  };

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>      
      {data ? (
        <>
          <Box mb={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box display="flex" alignItems="center">
                  <Typography variant="h6">
                    {t('reports.birthdayPetsTitle')} ({data.total_results || (data.content ? data.content.length : 0)})
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          
          {data.content && data.content.length > 0 ? (
            <>
              {data.content.map((pet) => (
                <Box key={pet.id} mb={2} onClick={() => handlePetClick(pet)} sx={{ cursor: 'pointer' }}>
                  <ListItemPet pet={pet} />
                </Box>
              ))}
              
              {data.total_pages && data.total_pages > 1 && (
                <Box display="flex" justifyContent="center" mt={2}>
                  <Pagination
                    count={data.total_pages}
                    page={page}
                    onChange={handlePageChange}
                    color="primary"
                  />
                </Box>
              )}
            </>
          ) : (
            <Box textAlign="center" p={3}>
              <Typography variant="body1">{t('reports.noBirthdayPets')}</Typography>
            </Box>
          )}
        </>
      ) : (
        <Box textAlign="center" p={3}>
          <Typography variant="body1">{t('common.noData')}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default BirthdayPetsReport; 